<template>
  <div class="box11" id="box11">
    <pageTitle
      title="他们已经拿下高新岗位"
      titleColor="#24375C"
    />
    <div class="swiper-content">
      <swiper :options="swiperOption2" ref="mySwiper2" class="swiperitems">
        <swiper-slide
          class="swiperwrap"
          v-for="(item, index) in 3"
          :key="index"
        >
          <img
            :src="require(`../../../assets/coursePage/ai2/box11/img${index}.png`)"
            alt
          />
        </swiper-slide>
      </swiper>

      <div class="swiper-pagination-box12"></div>
    </div>
  </div>
</template>

<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
import pageTitle from "../common/pageTitle.vue";
export default {
  components: {
    pageTitle,
    swiper,
    swiperSlide,
  },

  data() {
    return {
      
     
      
      swiperOption2: {
        loop: true, // 循环模式选项

        spaceBetween: 12,
        autoplay: true,
        centeredSlides: true,
        slidesPerView: "auto",
        coverflowEffect: {
          slideShadows: true, // 页面阴影效果
          rotate: 0, // 旋转的角度
          stretch: 50, // 拉伸   图片间左右的间距和密集度
          depth: 200, // 深度   切换图片间上下的间距和密集度
          modifier: 0.9, // 修正值 该值越大前面的效果越明显
        },
        pagination: {
          el: ".swiper-pagination-box12",
        },
      },
    };
  },
};
</script>

<style lang="less" scoped>
.box11 {
  padding: 80px 0 60px;

  width: 100%;
  
  /deep/ .swiper-container-free-mode > .swiper-wrapper {
    -webkit-transition-timing-function: linear; /*之前是ease-out*/
    -moz-transition-timing-function: linear;
    -ms-transition-timing-function: linear;
    -o-transition-timing-function: linear;
    transition-timing-function: linear;
    margin: 0 auto;
  }

  .content {
    margin: 0 auto;
    width: 686px;
    height: 96px;
    height: 864px;
    background: #ffffff;
    box-shadow: 0px 8px 24px 0px rgba(64, 128, 255, 0.12);
    border-radius: 24px;
    overflow: hidden;
    margin-top: 48px;

    -webkit-backface-visibility: hidden;
    -webkit-transform: translate3d(0, 0, 0);

    .border {
      background: linear-gradient(
        180deg,
        rgba(255, 255, 255, 1),
        rgba(255, 255, 255, 0)
      );

      padding: 2px;
      border-radius: 24px 24px 0 0;
      overflow: hidden;
      margin: -2px;
    }
    .swiperitems1 {
      border-radius: 0 0 24px 24px;
    }
    .swiperwrap {
      background-color: #ffffff !important;
      position: relative;
      z-index: 20;
    }
    .item {
      display: flex;

      text-align: center;
      height: 96px;
      background: #ffffff;
      line-height: 96px;
      font-family: PingFang SC;
      font-size: 24px;
      font-weight: normal;
      letter-spacing: 0px;
      color: #4e5969;
      box-sizing: border-box;
      border-bottom: 2px solid rgba(232, 243, 255, 0.8);
    }
    .name {
      width: 120px;
      height: 96px;
    }
    .name1 {
      border-radius: 24px 0 0 0;
    }
    .education {
      width: 80px;
      height: 96px;
    }
    .before {
      width: 128px;
      height: 96px;
    }
    .after {
      width: 128px;
      height: 96px;

      color: #165dff;
    }
    .unit {
      width: 230px;
      height: 96px;
    }

    .content-top {
      display: flex;
      height: 96px;
      box-sizing: border-box;
      // background: linear-gradient(180deg, #d7e3ff 0%, #f3f7ff 100%);
      background: url("../../../assets/coursePage/java/box9/topbgc.png")
        no-repeat;
      background-size: cover;
      width: 100%;
      div {
        // flex: 1;
        text-align: center;
        font-size: 24px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #1d2129;
        line-height: 96px;
      }
    }
  }

  .swiper-content {
    position: relative;
    padding-bottom: 38px;
    margin-top: 48px;

    img {
      padding: 4px;
      width: 374px;
      height: 662px;
      background: #f5f9ff;
      border-radius: 20px;
      box-sizing: border-box;
      transition: all 0.3s;
    }

    .swiper-slide {
      display: flex;
      align-items: center;
      padding: 4px;
      width: 403px;
      height: 742px;
      // background: #f5f9ff;
      border-radius: 20px;
      box-sizing: border-box;
    }
    .swiper-slide-active {
      img {
        width: 416px;
        height: 736px;
        border-radius: 24px;
        margin-left: -18px;
      }
    }
    .swiper-pagination-box12 {
      display: flex;
      align-items: center;
      position: absolute;
      left: 50%;
      bottom: 0px;
      transform: translate(-50%, 0px);
      background: rgba(46, 165, 252, 0.16);
      // width: 60px;
      // height: 6px;

      // // background: #70c3f7;
      // background: rgba(46, 165, 252, 0.16);
      // border-radius: 3px;
    }
  }

  /deep/ .swiper-pagination-bullet {
    width: 20px;
    height: 6px;
    background: rgba(46, 165, 252, 0.16);
    border-radius: 3px;
  }

  /deep/.swiper-pagination-bullet.swiper-pagination-bullet-active {
    width: 20px;
    height: 6px;
    background: #4b84fa;
    border-radius: 3px;
  }
}
</style>
